

import FetchHandler from '../../../assets/js/assets/FetchHandler';
import AlertHandler from '../../../assets/js/modules/alertHandler';

import { initGpsTrackingTable } from './GpsTrackingView';
import { GPSTrekkingDeatile, closeRoute } from './GPSTrekkingDeatile';


document.addEventListener('DOMContentLoaded', function () {

    // Funktionen import
    initGpsTrackingTable();
    GPSTrekkingDeatile();
    closeRoute();

    const submitForm = document.querySelector('#GpsRouteFrom');
    if(submitForm){
        submitForm.addEventListener('submit', 
            gpsRouteFrom
        )
    }
    
    async function gpsRouteFrom (event) {
        event.preventDefault();
        try {
            const { status, body } = await FetchHandler.sendFormData(event.target);
            if (status === 200 && body.success) {
                AlertHandler.showAlert(body.message, 'success');
            } else {
                AlertHandler.showAlert(body.errors || 'Ein Fehler ist aufgetreten', 'danger');
            }
        } catch (error) {
            AlertHandler.showAlert('Ein Fehler ist aufgetreten: ' + error, 'danger');
        }
    }
    

    const dataContainer = document.querySelector('#dataContainerOrder');
    if(!dataContainer) return
    
    // Fügt Standort-Icon zu Objektzeilen nach Tabellenladen hinzu.
    function observeElementOrder(selector, callback) {
        const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                callback();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    observeElementOrder('#calculation-tbody', () => {
        document.querySelectorAll('tr[data-type="object"]').forEach(modifyObjectRow);
    });


    function modifyObjectRow(row) {
        const firstTd = row.querySelector('td');
        const deleteDiv = firstTd.querySelector('.delete-object');
        const id = deleteDiv ? deleteDiv.getAttribute('data-id') : null;
        if (id) {
            pruefeRoute(id, firstTd);
        }
    }

    function pruefeRoute(id, firstTd) {
        const detailRouteUrl = DetailRoute.replace('/0/', `/${id}/`);

        fetch(detailRouteUrl)
            .then(response => response.json())
            .then(data => {
                const divContainer = firstTd.querySelector('.d-flex');
                const existingIcon = divContainer.querySelector(`.gpsModal[data-id="${id}"]`);
                if (data.length > 0) {
                    data.forEach(route => {
                        if (existingIcon) {
                            existingIcon.remove();
                        }
                        const existingCell = firstTd.closest('tr').querySelector('td[colspan="8"]');
                        if (existingCell) {                            
                            const newDiv = document.createElement('div');
                            newDiv.style.cursor = 'pointer';
                            const icon = document.createElement('i');
                            icon.classList.add('fa-solid', 'fa-route');
                            console.log(route.is_closed)
                            if(route.is_closed){
                                icon.classList.add('text-success');
                            }else{
                                icon.classList.add('text-danger');
                            }
                            newDiv.appendChild(icon);
                            divContainer.appendChild(newDiv);
                            const templateRoute = gpsDetaile.replace('/0/', `/${route.id}/`);
                            newDiv.setAttribute('data-detail-route', templateRoute); 
                            newDiv.addEventListener('click', function() {
                                const detailRouteUrl = gpsDetaile.replace('/0/', `/${id}/`);
                                window.location.href = detailRouteUrl;
                            });
                        }
                    })
                }
            })
            .catch(error => console.error('Fehler beim Prüfen der Route:', error));
    }

});